var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"network-counselors"}},[_c('header-section',{attrs:{"title":"Mạng lưới cố vấn"}}),_vm._v(" "),_c('div',{staticClass:"network-counselors-content container"},[_c('tool-filter',{staticClass:"col-md-4"}),_vm._v(" "),_c('counselors',{staticClass:"col-md-8"})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38027377","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/NetworkCounselors.vue
// module id = null
// module chunks = 